const API = `${process.env.REACT_APP_BACKEND_URL}/api/marketing-events`;

const hasAnalyticsConsent = () => {
  try {
    return JSON.parse(localStorage.getItem('simplifi_cookie_preferences') || '{}').analytics === true;
  } catch {
    return false;
  }
};

export const trackMarketingEvent = (event, data) => {
  if (!hasAnalyticsConsent()) return;
  const body = JSON.stringify({ event, ...data });
  if (navigator.sendBeacon) {
    navigator.sendBeacon(API, new Blob([body], { type: 'application/json' }));
  } else {
    fetch(API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
  }
};
